const EventBus = window.VueEventBus

export default {
  name: 're-form',
  props: {
    formClass: {
      type: [String, Array, Object],
      default: ''
    },
    title: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    successMessage: {
      type: String,
      default: null,
    },
    noActions: {
      type: Boolean,
      default: false
    },
    submitButtonTitle: {
      type: String,
      default: 'Submit',
    },
    disableSubmitButton: {
      type: Boolean,
      default: false,
    },
    noResetButton: {
      type: Boolean,
      default: false
    },
    resetButtonTitle: {
      type: String,
      default: 'Reset',
    },
    disableResetButton: {
      type: Boolean,
      default: false
    },
    isSuccess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isProcessing: false,
      isValid: false
    }
  },

  watch: {
    isSuccess(val) {
      this.isProcessing = false
      this.isValid = val
    },
    errorMessage(val) {
      this.isProcessing = false
      this.isValid = false
    }
  },

  computed: {
    hasErrorMessage() {
      return !_.isEmpty(this.errorMessage)
    },
    hasSuccessMessage() {
      return !_.isEmpty(this.successMessage)
    },
    showMessage() {
      return (this.hasErrorMessage && !this.isValid) || (this.hasSuccessMessage && this.isValid)
    },
    messageType() {
      return (this.hasErrorMessage && !this.isValid) ? 'danger' : 'success'
    },
    alertMessage() {
      let message = ''
      if (this.hasErrorMessage && !this.isValid) {
        message = this.errorMessage
      }
      if (this.hasSuccessMessage && this.isValid) {
        message = this.successMessage
      }
      return message
    }
  },

  methods: {
    clickReset() {
      this.$emit('reset')
      EventBus.$emit('form-reset')
    },
    clickSubmit() {
      this.isProcessing = true
      this.$emit('submit')
      EventBus.$emit('form-submit')
    }
  },
}
